﻿const systemUrls: ISystemUrls = {
    async: '/WebPortal/async.aspx',
    asyncReadOnly: '/WebPortal/AsyncReadOnly.aspx',
};

if (!window.opacc) {
    window.opacc = {};
}

if (!window.opacc.systemUrls) {
    window.opacc.systemUrls = {};
}

window.opacc.systemUrls = systemUrls;
